import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AuthService } from '../../shared-module/services/auth.service';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  imports: [
    CommonModule,
    RouterModule,
    DatePipe
  ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {

  currentDate = new Date();

  constructor(
    public authService: AuthService
  ) {
  }

}
